import type { ListTileSpec } from "../ListTiles";
import type { ChartChip } from "../ChartChips";
import { pct, fmtCount } from "../listMath";
import { MVA_WORKING } from "@shared/dashboardOrigination";
import { PROSPECT_STAGES } from "@shared/prospectConstants";

export interface ProspectTileRow { parked: boolean; stage: string | null; hasSource: boolean; hasNextStep: boolean }

export function prospectTiles(rows: ProspectTileRow[], openMvas: { status: string }[]): ListTileSpec[] {
  const active = rows.filter((r) => !r.parked);
  const nurturing = rows.length - active.length;
  const sourced = active.filter((r) => r.hasSource).length;
  const next = active.filter((r) => r.hasNextStep).length;
  const working = openMvas.filter((m) => MVA_WORKING.includes(m.status)).length;
  return [
    { key: "active", label: "Active prospects", value: active.length, sub: `${fmtCount(nurturing)} nurturing` },
    { key: "source", label: "Source recorded", value: sourced, sub: `${pct(sourced, active.length)}% have a source`,
      coverage: { covered: sourced, total: active.length, title: `${fmtCount(sourced)} of ${fmtCount(active.length)} have a source` } },
    { key: "next", label: "Next step set", value: next, sub: `${fmtCount(active.length - next)} have no next step`,
      coverage: { covered: next, total: active.length, title: `${fmtCount(next)} have a next step` } },
    { key: "mvas", label: "MVAs open", value: openMvas.length, sub: `${fmtCount(working)} in progress · ${fmtCount(openMvas.length - working)} waiting` },
  ];
}

export function prospectStageChips(rows: ProspectTileRow[]): ChartChip[] {
  const active = rows.filter((r) => !r.parked);
  return PROSPECT_STAGES.map((s) => ({ key: s, label: s, count: active.filter((r) => (r.stage || "Identified") === s).length }));
}
